import { useRef } from "react";
import { IconButton } from "@material-ui/core";
import ClearIcon from '@material-ui/icons/Clear';
import { BundleLink, ButtonCustom, ImportFileUpload } from "../../shared/Style/Style";
import { ImagesBlock, ImagesTitle } from "../styles";
import { TrainerContext } from "../context";

export const TrainerImagesBlock = ({ onDeleteFile }: { onDeleteFile: (key: string) => void }) => {
    const previewImageInput = useRef<HTMLInputElement | null>(null);
    const webpGifImageInput = useRef<HTMLInputElement | null>(null);
    const mp4GifImageInput = useRef<HTMLInputElement | null>(null);

    const imagesData = [
        {
            key: "previewImage",
            label: "Preview png *",
            inputRef: previewImageInput,
            acceptType: ".png",
        },
        {
            key: "webpGifImage",
            label: "Gif webp *",
            inputRef: webpGifImageInput,
            acceptType: ".webp",
        },
        {
            key: "mp4GifImage",
            label: "Gif mp4 *",
            inputRef: mp4GifImageInput,
            acceptType: ".mp4",
        },
    ];

    const uploadImageHandler = (file: File, callback: (file: File) => void) => {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            callback(file);
        };
        reader.readAsDataURL(file);
    };

    return (
        <TrainerContext.Consumer>
            {({ data, updateTrainerData }) => (
                <div>{imagesData.map(({ key, label, inputRef, acceptType }) => (
                    <ImagesBlock>
                        <ImagesTitle>{label}</ImagesTitle>
                        {data[key] ? (
                            <div key={key}>
                                <BundleLink href={data.previewImage?.original} download>файл завантажений</BundleLink>
                                <IconButton
                                    onClick={() => {
                                        onDeleteFile(key);
                                        updateTrainerData(key, null);
                                    }}
                                >
                                    <ClearIcon color="error" fontSize="small" />
                                </IconButton>
                            </div>
                            ) : (
                                <ButtonCustom
                                    onClick={() => inputRef?.current?.click()}
                                >
                                    <span>Прикріпити</span>
                                    <ImportFileUpload
                                        key={key}
                                        type="file"
                                        accept={acceptType}
                                        ref={inputRef}
                                        onChange={({ target: { files } }) =>
                                            files[0] &&
                                            uploadImageHandler(files[0], (file) => {
                                                updateTrainerData(key, file);
                                            })
                                        }
                                    />
                                </ButtonCustom>
                            )}
                    </ImagesBlock>)
                )}
                </div>
            )}
        </TrainerContext.Consumer>
    );
};
